import { useParams } from 'react-router-dom';
import React from 'react';
import { MeetingDetailsContent } from 'src/meetings/detail/MeetingDetailsContent';

export const MeetingDetailPage = () => {
  const { eventId, eventTab } = useParams<{
    eventId: string;
    eventTab?: string;
  }>();
  return (
    eventId && (
      <MeetingDetailsContent
        eventId={eventId}
        onDelete={() => {}}
        basePath={`/meetings/${eventId}`}
        tab={eventTab}
      />
    )
  );
};
